import React from 'react'
import WhiteLogo from '../../media/OncallogyWhiteFullText.png'
import IconButton from 'material-ui/IconButton';
import {  MoreVert } from 'material-ui-icons';
import {  HighlightOff } from 'material-ui-icons';
import { MenuItem } from 'material-ui/Menu';
import  mui from '../../themes/mui'
import presets from '../../lib/presets'
import { navigateTo } from "gatsby-link"
import Link from 'baseComponents/link'
import { applicationStyles } from 'themes'
import Badge from 'material-ui/Badge';
import { colors } from 'themes'
import withAuth, { publicAuth } from 'components/hocs/withAuth'

const logo = <Badge style={{color: colors.green }} badgeContent="beta" ><Link to='/'><img src={WhiteLogo} height={35}/></Link></Badge>

const styles = {
  horizontalMenu: {
    display: 'none',
    [presets.Tablet]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
    }
  },
  mobileMenuIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    [presets.Tablet]: {
      display: 'none'
    }
  },
  fullScreenMenu: {
    position: 'fixed',
    zIndex: 10,
    backgroundColor: colors.white,
    left: 0,
    right: 0,
    top: 0,
    bottom:0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  toolbar: {
    display: 'flex',
    backgroundColor: colors.mainBlue,
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center'
  },
  main: {
    display: 'flex',
    ...applicationStyles.mainTextContainer,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoMenuHolder: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  menuItem: {
    color: colors.white,
    margin: '10px',
    cursor: 'pointer',
  },
}

class Header extends React.Component {
  constructor() {
    super()
    this.state = {
      menuOpen: false,
    }
    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
  }

  openMenu(event) {
    this.setState({ menuOpen: true })
  }

  closeMenu() {
    this.setState({ menuOpen: false })
  }

  navigate(location) {
    navigateTo(location)
    this.closeMenu()
  }

  render() {
    const initials = (this.props.user && `${this.props.user.first_name[0].toUpperCase()}${this.props.user.last_name[0].toUpperCase()}`) || "O"
    const menuItems = (color) => [
      <a key={1} style={{...styles.menuItem, color: color }} onClick={() => this.navigate('/forProviders')}>Providers</a>,
      <a key={2} style={{...styles.menuItem, color: color }} onClick={() => this.navigate('/forEmployers')}>Employers</a>,
      <a key={3} style={{...styles.menuItem, color: colors.white, backgroundColor: colors.green, padding: 10, borderRadius: 10 }} onClick={() => this.navigate('/beta')}>Sign up!</a>,
      <a key={4} style={{...styles.menuItem, color: color }} onClick={() => this.navigate('/login')}>Login</a>,
    ]

    const loggedInMenuItems = (color) => [
      <a key={1} style={{...styles.menuItem, color: color }} onClick={() => this.navigate('/app/opportunities')}>Opportunities</a>,
      <a key={2} style={{...styles.menuItem, color: color }} onClick={() => this.navigate('/app/credentialing')}>Credentialing</a>,
    ]

    const user = this.props.user
    const loggedInIcon = (onClick) => <a key={3} style={{...styles.menuItem, color: colors.white, backgroundColor: colors.green, padding: 10, borderRadius: '100%' }} onClick={onClick}>{initials}</a>
    const profileLink = <a key={5} style={{...styles.menuItem, color: colors.mainBlue }} onClick={() => this.navigate('/app/profile')}>Profile</a>
    return (
      <div css={styles.toolbar} >
        <div css={styles.main}>
          {logo}
          <div css={styles.horizontalMenu}>
            {user ? [...loggedInMenuItems(colors.white), loggedInIcon(() => this.navigate('/app/profile'))] : menuItems(colors.white)}
          </div>
          <div css={styles.mobileMenuIcon}>
            {user ? loggedInIcon(this.openMenu) : <MoreVert onClick={this.openMenu} color={colors.white}/> }
          </div>
        </div>
        { this.state.menuOpen &&
          <div css={styles.fullScreenMenu}>
            <div css={{ position: 'fixed', top: '20px', left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}} >
              <HighlightOff style={{ cursor: 'pointer'}}size={32} onClick={this.closeMenu} color={colors.darkBlue}/>
            </div>
            {user ? [...loggedInMenuItems(colors.mainBlue), profileLink] : menuItems(colors.mainBlue) }
          </div>
        }
      </div>
    )
  }
}

export default withAuth(Header, publicAuth)


// WEBPACK FOOTER //
// ./src/components/hybrid/header.js